// Hook do pobierania typów procesów

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IProcessType {
  value: string;
  text: string;
}

interface IResponse {
  items: IProcessType[];
}

const getProcessTypes = (): Promise<IResponse> =>
  axios.get('/dev-studio/process/types');

export const useGetProcessTypes = (
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['processTypes'], () => getProcessTypes(), options);
